// export const ICON_SIZE = [`22px`, null, null, '24px']
export const ICON_SIZE = '24px'
